import * as settings from '../settings';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import AlertModal from './AlertModal';
import LandingModal from "./LandingModal";
import Map from './Map';
import Navbar from './Navbar';
import { fetchTrackerReports } from "../actions/api";
import { fetchGeolocation } from "../actions/geolocation";

const mapStateToProps = state => ({
  ...state.map,
});

const mapDispatchToProps = dispatch => ({
  fetchReports: imei => {
    dispatch(fetchTrackerReports(imei));
  },

  fetchGeolocation: () => {
    dispatch(fetchGeolocation());
  }
});

class MapPage extends Component {
  componentDidMount() {
    if (!settings.IS_ROLE_USER) {
      this.props.fetchGeolocation();
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.tracker !== nextProps.tracker) {
      this.props.fetchReports(nextProps.tracker);
    }
  }

  render() {
    return (
      <>
        {settings.IS_ROLE_USER && this.props.reports.length == 0 ? <AlertModal show={true} title="Lokalizator GPS" message="Brak danych z lokalizatora GPS."/> : null}
        {!settings.IS_ROLE_USER ? <LandingModal show={true}/> : null}
        <Navbar/>
        <Map center={this.props.center} reports={this.props.reports}/>
      </>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MapPage);
